<template>
  <div class="flex-1 w-0 h-100 flex-column ptb-10 pr-20">
    <div class="flex content-top mb-10">
      <div class="flex-1 bg-ff h-100 flex align-center pl-10 mr-10">
        <div class="flex align-center mr-20 cursor" v-for="(item, index) in currentClassify.tab" :key="index" @click="changeStatus(index )">
          <div class="mr-5" :class="index === tabIndex ? 'decoration-line' : 'decoration-line-hui'"></div>
          <div class="font-bold" :class="index === tabIndex ? 'font-16-f5971d' : 'font-16-30313a'">{{item.name}}</div>
        </div>
      </div>
      <div class="flex  align-center ">
        <el-date-picker
          v-model="startTime"
          type="date"
          placeholder="开始时间"
          value-format="yyyy-MM-dd">
        </el-date-picker>
        <span class="font-12-b9b9b9" style="width: 24px;border: 1px solid #e2e2e2;height: 30px; line-height: 30px;">至</span>
        <el-date-picker
          v-model="endTime"
          type="date"
          placeholder="结束时间"
          value-format="yyyy-MM-dd">
        </el-date-picker>
      </div>
      <div class="flex align-center ml-10">
        <el-select class="flex-1" v-model="selectSupplier" >
          <el-option v-for="(item, index) in supplier" :key="index" :label="item.name" :value="index"></el-option>
        </el-select>
      </div>
      <div class="flex ml-10">
        <div class="flex align-center bg-ff h-30 border-e2 border-ra mr-10 search">
          <img src="/static/images/sousuo.png" class="icon-14 ml-10 mr-5" alt="">
          <el-input class="border-none" type="text" placeholder="材料名称/编码/规格/型号" v-model="keywords" clearable @keyup.enter.native="onSearch"></el-input>
        </div>
        <button class="btn-30-bg-82b925" @click="onSearch">搜索</button>
      </div>
    </div>
    <div class="mb-5 flex flex-wrap" v-if="currentClassify.btnList">
      <div class="flex align-center mr-5 mb-5" :class="index === Index ? 'btn-24-bg-f5971d' : 'btn-24-bg-ff' " @mouseenter="enter(index)" @mouseleave="leave(index)" v-for="(item, index) in currentClassify.btnList" :key="index" @click="btnClick(item.name)">
        <img :src="index === Index ? item.iconActive : item.icon" class=" mr-5" :class="item.iconStatus ===1 ? 'icon-12-14':'icon-14'" alt="">
        <div>{{item.name}}</div>
      </div>
    </div>
    <div class="flex-1 h-0 flex-column">
      <div class="flex-1 h-0 materialTable">
        <erp-table ref="erpTable" :table-footer="tableFooter1" :table-data="tableData" :loading="loading" :check-control="true" :not-cell="true"
                   @select-change="selectChange" @on-detail="onDetail"  :column-data="columnData"></erp-table>
      </div>
      <pagination :page-size="pages" :page-no="page" v-model="page" :page-total="limit" :total="total" @on-jump="jump"></pagination>
    </div>
    <div class="filtrate">
      <el-dialog :visible.sync="showDialog" width="85%" :show-close="false">
        <div class="header">
          <!--<div class="font-bold " :class="founddetail.status === 1 ? 'font-22-30313a': 'font-22-ff5555'">{{founddetail.status === 1 ? '收款单据':'退款单据'}}</div>-->
          <div class="font-bold font-22-30313a" >生成采购付款单</div>
          <i class="el-icon-close close1"  @click="showDialog = false"></i>
        </div>
        <!--<div class="p-absolute" style="top: 0;left: 20px;"><img :src="founddetail.status ===1 ? '/static/images/weijizhang.png' : '/static/images/yijizhang.png'" style="width: 15px;height: auto" alt=""></div>-->
        <!--<div class="p-absolute" style="top: 0;left: 20px;"><img src="/static/images/weijizhang.png" style="width: 15px;height: auto" alt=""></div>-->
        <div class="bg-f3f4f7 plr-20 ptb-10">
          <div class=" flex text-left align-center">
            <div class="flex-1 mr-40">
              <div class="font-12-30313a mb-5"><span class="font-12-b9b9b9">单据编号：</span>-</div>
              <div class="font-12-30313a">
                <span class="font-12-b9b9b9">付款账号：</span>
                <el-select class="flex-1" v-model="accountIndex" placeholder="请选择" >
                  <el-option v-for="(item, index) in optionList" :key="index" :label="item.name"  :value="index"></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex-1 mr-40">
              <div class="font-12-30313a mb-5"><span class="font-12-b9b9b9">供应商：</span>{{currentSupplier.name}}</div>
              <div class="font-12-30313a flex align-center">
                <span class="font-12-b9b9b9">对方账号：</span>
                <el-input placeholder="请输入" v-model="newOrder.counterAccount" class="flex-1" ></el-input>
              </div>
            </div>
            <div class="flex-2">
              <div class="font-12-30313a flex mb-5 align-center">
                <div class="flex"><span class="font-12-b9b9b9">开单人员：</span>{{this.$store.state.user.name}}</div>
                <div class="flex flex-1 justify-end"><span class="font-12-b9b9b9">开单时间：</span>{{createTime}}</div>
              </div>
              <div class="font-12-30313a flex align-center">
                <span class="font-12-b9b9b9">单据摘要：</span>
                <el-input placeholder="请输入" v-model="newOrder.description" class="flex-1" ></el-input>
              </div>
            </div>
          </div>
        </div>
        <div class="plr-20 ptb-10">
          <div style="height: 250px">
            <erp-table :table-data="dialogTableData" :is-edit="true" @on-modify="onModify" modify-method="on-modify" :loading="loading" :column-data="dialogTableColumn" :table-footer="tableFooter"></erp-table>
          </div>
        </div>
        <div slot="footer">
          <button class="btn-30-bg-82b925 mr-10" @click="save(true)" :disabled="lockLoading">保存并打印</button>
          <button class="btn-30-bg-f5971d-s" @click="save(false)" :disabled="lockLoading">保存</button>
        </div>
      </el-dialog>
    </div>
    <div class="filtrate">
      <el-dialog :visible.sync="showBadDialog" width="85%" :show-close="false">
        <div class="header">
          <!--<div class="font-bold " :class="founddetail.status === 1 ? 'font-22-30313a': 'font-22-ff5555'">{{founddetail.status === 1 ? '收款单据':'退款单据'}}</div>-->
          <div class="font-bold font-22-ff5555" >生成坏账核销单</div>
          <i class="el-icon-close close1"  @click="showBadDialog = false"></i>
        </div>
        <!--<div class="p-absolute" style="top: 0;left: 20px;"><img :src="founddetail.status ===1 ? '/static/images/weijizhang.png' : '/static/images/yijizhang.png'" style="width: 15px;height: auto" alt=""></div>-->
        <!--<div class="p-absolute" style="top: 0;left: 20px;"><img src="/static/images/weijizhang.png" style="width: 15px;height: auto" alt=""></div>-->
        <div class="bg-f3f4f7 plr-20 ptb-10">
          <div class="text-left">
            <div class="flex align-center">
              <div class="font-12-30313a mb-5 flex-1"><span class="font-12-b9b9b9">单据编号：</span>-</div>
              <div class="font-12-30313a mb-5 flex-1"><span class="font-12-b9b9b9">供应商：</span>{{currentSupplier.name}}</div>
              <div class="font-12-30313a mb-5 flex-1"><span class="font-12-b9b9b9">开单人员：</span>{{this.$store.state.user.name}}</div>
              <div class="font-12-30313a mb-5 flex-1"><span class="font-12-b9b9b9">开单时间：</span>{{createTime}}</div>
            </div>
          </div>
          <div class="font-12-30313a flex align-center"><span class="font-12-b9b9b9">单据摘要：</span><el-input placeholder="请输入" v-model="newOrder.description" class="flex-1" ></el-input></div>
        </div>
        <div class="plr-20 ptb-10">
          <div style="height: 250px">
            <erp-table :table-data="dialogTableData" :loading="loading" :is-edit="true" @on-modify="onModify" modify-method="on-modify" :column-data="dialogTableColumn" :table-footer="tableFooter"></erp-table>
          </div>
        </div>
        <div slot="footer">
          <button class="btn-30-bg-82b925 mr-10" @click="savePrint" :disabled="lockLoading">保存并打印</button>
          <button class="btn-30-bg-f5971d-s" @click="saveOnly" :disabled="lockLoading">保存</button>
        </div>
      </el-dialog>
    </div>
    <el-dialog title="单据打印" :visible.sync="isReportShow" :fullscreen="true" class="flex-column" width="85%">
      <report :classify-id="9" :id="billId"></report>
    </el-dialog>
    <edit-receipt ref="editReceipt" :receiptStatus="1" :orderDefine="billInfo" :detailItem="currentBill" v-if="editFlag" :isEdit="false" :btnPermissions="btnPermissions"></edit-receipt>
  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import MoveHorizon from '@/components/MoveHorizon'
import MoveVertical from '@/components/MoveVertical'
import ErpTable from '@/components/ErpTable'
import Report from '@/components/Report'
import EditReceipt from '@/components/AddReceipt'
export default {
  name: 'OutstandingOrder',
  components: {Pagination, MoveHorizon, ErpTable, MoveVertical, Report, EditReceipt},
  props: ['currentClassify', 'supplier', 'optionList'],
  data () {
    return {
      btnPermissions: ['print'],
      keywords: '',
      total: 0,
      page: 1,
      pages: 0,
      limit: 50,
      startTime: '',
      endTime: '',
      selectSupplier: 0,
      tabIndex: 0,
      Index: -1,
      tableFooter1: [
        {
          columns: ['totalCostNew', 'paidAmount', 'undoAmount'],
          type: 'sum',
          name: '合计'
        }
      ],
      columnData: [
        {
          type: 'selection',
          width: '40',
          fixed: 'left'
        }, {
          field: 'operate',
          title: '操作',
          width: '70',
          fixed: 'left',
          isDefine: true,
          child: [{
            className: 'btn-16-bg-85 btn-hover mr-5',
            title: '详情',
            methodName: 'on-detail',
            type: 'btn'
          }]
        }, {
          field: 'status',
          title: '单据状态',
          width: '100',
          formatter: 'toOrderStatus'
        }, {
          field: 'name',
          title: '单据名称',
          width: '110'
        }, {
          field: 'code',
          title: '单据号',
          width: '150'
        }, {
          field: 'completeTime',
          title: '供货完成日期',
          width: '100',
          formatter: ['toDateString', 'yyyy-MM-dd']
        }, {
          field: 'businessName',
          title: '供应商',
          width: '230'
        }, {
          field: 'customerAddress',
          title: '客户/装修地点',
          minWidth: '200'
        }, {
          field: 'pmName',
          title: '项目经理',
          width: '100'
        }, {
          field: 'totalCostNew',
          title: '应付金额',
          width: '100'
        }, {
          field: 'paidAmount',
          title: '实付金额',
          width: '100'
        }, {
          field: 'undoAmount',
          title: '未付金额',
          width: '100'
        }
      ],
      loading: false,
      tableData: [],
      showDialog: false,
      isReportShow: false,
      showBadDialog: false,
      editFlag: false,
      dialogTableColumn: [
        {
          type: 'index',
          title: '序号',
          width: '60',
          fixed: 'left'
        }, {
          field: 'name',
          title: '单据名称',
          width: '110'
        }, {
          field: 'code',
          title: '材料单据号',
          width: '150'
        }, {
          field: 'planBill',
          title: '应付金额',
          width: '100'
        }, {
          field: 'realBill',
          title: '实付金额',
          width: '100',
          editRender: {
            name: 'input'
          }
        }, {
          field: 'remark',
          title: '备注',
          width: '',
          editRender: {
            name: 'input'
          }
        }
      ],
      tableFooter: [
        {
          columns: ['planBill', 'realBill'],
          type: 'sum',
          name: '合计'
        }
      ],
      dialogTableData: [],
      newOrder: {},
      createTime: '',
      accountIndex: 0,
      currentSupplier: {},
      billId: 0,
      currentBill: {},
      billInfo: {},
      lockLoading: false
    }
  },
  created () {
    this.getData()
  },
  mounted () {},
  methods: {
    onDetail (row) {
      this.axios.post('orderDefine/findOne', {companyId: this.$store.state.companyId, type: row.type}).then(res => {
        if (res.data.success) {
          this.currentBill = row
          this.billInfo = res.data.data
          this.editFlag = true
          this.$nextTick(() => {
            this.$refs.editReceipt.getData()
            this.$refs.editReceipt.tableData = []
            this.$refs.editReceipt.addVisible = true
          })
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            offset: 400
          })
        }
      })
    },
    saveOnly () {
      this.save(false)
    },
    savePrint () {
      this.save(true)
    },
    save (isPrint) {
      this.lockLoading = true
      let orderBillItemParamList = []
      console.log(this.dialogTableData)
      for (let i = 0; i < this.dialogTableData.length; i++) {
        orderBillItemParamList.push({
          orderCode: this.dialogTableData[i].code,
          orderId: this.dialogTableData[i].id,
          planBill: this.dialogTableData[i].planBill,
          realBill: this.dialogTableData[i].realBill,
          name: this.dialogTableData[i].name,
          description: this.dialogTableData[i].remark
        })
      }
      if (this.showDialog) {
        this.newOrder.accountId = this.optionList[this.accountIndex].id
        this.newOrder.account = this.optionList[this.accountIndex].name
      } else {
        delete this.newOrder.counterAccount
      }
      this.newOrder.orderBillItemParamList = orderBillItemParamList
      this.axios.post('orderBill/save', this.newOrder).then(res => {
        if (res.data.success) {
          this.$message.success('保存成功')
          this.showDialog = false
          this.showBadDialog = false
          if (isPrint) {
            this.billId = res.data.data.id
            this.isReportShow = true
          }
          this.getData()
          this.currentSupplier = {}
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            offset: 400
          })
        }
      })
      setTimeout(() => {
        this.lockLoading = false
      }, 5000)
    },
    // selectAll (checked) {
    //   console.log(checked)
    //   this.$refs.erpTable.setAllSelection(false)
    // },
    selectChange (checked, row) {
      if (!checked) {
        let dataArr = this.$refs.erpTable.getSelectEvent()
        if (dataArr.length === 0) {
          this.currentSupplier = {}
        }
      } else {
        this.currentSupplier = {
          id: row.businessId,
          name: row.businessName
        }
      }
    },
    checkMethod (row) {
      // console.log(999999)
      if (this.currentSupplier && this.currentSupplier.id) {
        return row.businessId === this.currentSupplier.id
      } else {
        return true
      }
    },
    getData () {
      let params = {
        page: this.page,
        limit: this.limit,
        companyId: this.$store.state.companyId,
        businessId: this.supplier[this.selectSupplier].id,
        keywords: this.keywords,
        startCompleteTime: this.startTime,
        endCompleteTime: this.endTime
      }
      this.loading = true
      this.axios.post('order/queryUndo', params).then(res => {
        this.loading = false
        if (res.data.success) {
          let list = res.data.data.list
          var reg = new RegExp('null', 'g')
          for (let i = 0; i < list.length; i++) {
            list[i].customerAddress = (list[i].customerName + '/' + list[i].address).replace(reg, '')
          }
          this.tableData = list
          this.total = res.data.data.total
          this.pages = res.data.data.pages
        } else {
          this.$message({
            type: 'error',
            message: res.data.msg,
            offset: 400
          })
        }
      })
    },
    onSearch () {
      this.page = 1
      this.currentSupplier = {}
      this.$refs.erpTable.setAllSelection(false)
      this.getData()
    },
    changeStatus (index) {
      this.tabIndex = index
    },
    onModify (row, column, colName) {
      if (colName === 'realBill') {
        row.realBill = parseInt(row[colName])
      }
    },
    btnClick (name) {
      let dataArr = this.$refs.erpTable.getSelectEvent()
      if (!dataArr.length) {
        this.$message({
          message: `请先选择要设置的单据`,
          type: 'warning'
        })
        return
      }
      this.dialogTableData = []
      for (let i = 0; i < dataArr.length; i++) {
        dataArr[i].planBill = dataArr[i].totalCostNew
        dataArr[i].realBill = dataArr[i].undoAmount
        this.dialogTableData.push(dataArr[i])
      }
      this.createTime = this.Utils.formatTime(new Date())
      this.accountIndex = 0
      this.newOrder = {
        companyId: this.$store.state.companyId,
        businessId: this.currentSupplier.id,
        businessName: this.currentSupplier.name,
        description: '',
        counterAccount: ''
      }
      switch (name) {
        case '生成材料付款单':
          this.showDialog = true
          this.newOrder.type = 1
          break
        case '生成坏账核销单':
          this.newOrder.type = 2
          this.showBadDialog = true
          break
      }
    },
    jump (page) {
      this.page = page
      this.getData()
    },
    enter (a) {
      this.Index = a
    },
    leave () {
      this.Index = -1
    }
  },
  watch: {
    keywords (val) {
      if (val === '') {
        this.currentSupplier = {}
        this.$refs.erpTable.setAllSelection(false)
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .filtrate /deep/ .el-dialog__wrapper{
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .filtrate /deep/ .el-dialog{
    border-radius: 6px;
    margin: 0!important;
    max-height: 100%;
    height: auto;
  }
  .filtrate /deep/ .el-dialog__header{
    display: none;
  }
  .filtrate /deep/ .el-dialog__body{
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  .header{
    border-bottom:1px solid #e2e2e2;
    padding: 14px;
    position: relative;
  }
  .close1{
    color: #30313a;
    font-size: 22px;
    font-weight: bold;
    position: absolute;
    top:10px;
    right: 10px;
    background: #ffffff;
  }
  .decoration-line{
    width: 4px;
    height: 16px;
    background-color: #f5971d;
    border-radius: 4px;
  }
  .decoration-line-hui{
    width: 4px;
    height: 16px;
    background-color: #e2e2e2;
    border-radius: 4px;
  }
  .content-top {
    height: 30px;
    .tab-item {
      font-size: 16px;
      color: #272727;
      display: flex;
      align-items: center;
      line-height: 30px;
      margin-right: 15px;
      cursor: pointer;
      span {
        height: 16px;
      }
      &.active {
        color: #f5971d;
      }
    }
  }
  .el-icon-zoom-in {
    position: absolute;
    bottom: 10px;
    right: 10px;
    font-size: 14px;
    color: #30313a;
  }
  .font-13-f5971d {
    font-size: 13px;
    color: #f5971d;
  }
  .el-card {
    height: 90px;
    border: 1px solid #e2e2e2;
    cursor: pointer;
  }
  .info-item {
    width: 198px;
    border-bottom: 1px solid #e2e2e2;
    display: flex;
    align-items: center;
    margin-top: 10px;
    font-size: 12px;
    color: #30313a;
    margin-right: 30px;
    line-height: 20px;
    height: 20px;
  }
  .search {
    overflow: hidden;
  }
  .search /deep/.el-input__inner{
    padding-left: 0;
    border: none;
    outline: none;
  }
  .materialTable /deep/ .vxe-header--row .vxe-cell--checkbox{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/pages/financeManage/comp/OutstandingOrder.vue